import axios from '~/api/axiosBase'

import { handleCloudflareChallenge, isCloudflareChallenge } from './cloudflare'

async function useSuccessReponseInterceptor(response) {
  if (isCloudflareChallenge(response)) {
    const config = await handleCloudflareChallenge(response.config)
    return axios(config)
  }
  return response
}

async function useErrorReponseInterceptor(error) {
  error.message = error.response?.data?.message || error.message

  if (isCloudflareChallenge(error?.response)) {
    const config = await handleCloudflareChallenge(error.config)
    return axios(config)
  }

  return Promise.reject(error)
}

export {
  useSuccessReponseInterceptor,
  useErrorReponseInterceptor,
}
